import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Elapsed Days ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Daily Interest ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs" }, "without margin", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Daily Interest ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs" }, "with margin", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Interest Accrual ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RHCPinned = _resolveComponent("RHCPinned")!
  const _component_RHC = _resolveComponent("RHC")!
  const _component_RBCPinned = _resolveComponent("RBCPinned")!
  const _component_RBC = _resolveComponent("RBC")!
  const _component_RT = _resolveComponent("RT")!

  return (_openBlock(), _createBlock(_component_RT, { class: "text-right" }, {
    thead: _withCtx(() => [
      _createVNode(_component_RHCPinned, { class: "text-center w-32 whitespace-pre-line" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_RHC, { class: "text-right" }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_RHC, { class: "text-right" }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_RHC, { class: "whitespace-pre-line text-right" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    tbody: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breakdown, (day, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: index,
          class: _normalizeClass(["group hover:bg-gray-300 transition-colors ease-in-out delay-300", index % 2 === 0 ? 'bg-white' : 'bg-gray-100'])
        }, [
          _createVNode(_component_RBCPinned, {
            class: _normalizeClass(["text-center group-hover:bg-gray-300 transition-colors ease-in-out delay-300", index % 2 === 0 ? 'bg-white' : 'bg-gray-100'])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(index + 1), 1)
            ]),
            _: 2
          }, 1032, ["class"]),
          _createVNode(_component_RBC, { class: "text-right" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatCurrency(day.withoutMargin.amount, day.withoutMargin.currency)), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_RBC, { class: "text-right" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatCurrency(day.withMargin.amount, day.withMargin.currency)), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_RBC, { class: "text-right" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatCurrency(day.interest.amount, day.interest.currency)), 1)
            ]),
            _: 2
          }, 1024)
        ], 2))
      }), 128))
    ]),
    _: 1
  }))
}